import { X } from "lucide-react";

export function IngredientUnitItem({ ingredientUnit, onDelete }) {
  return (
    <span className="flex items-center gap-2 pl-3 pr-2 py-1.5 bg-gray-50 border border-gray-200 rounded-full text-sm font-medium text-gray-700">
      {ingredientUnit.unit}
      <button
        onClick={() => onDelete(ingredientUnit.unitId)}
        aria-label={`Delete ${ingredientUnit.unit} unit`}
        className="p-0.5 rounded-full text-gray-400 hover:bg-red-100 hover:text-red-600 transition-colors"
      >
        <X size={14} />
      </button>
    </span>
  );
}
